import { dictionaryMap } from '../../assets/dictionaries/dictionary';
import { shallowEqual, useSelector } from 'react-redux';

export const useGttdValues = () => {
    const { user } = useSelector(
        ({ auth }) => ({
            user: auth.user
        }),
        shallowEqual
    );

    let dictionary = user ? dictionaryMap[user.language_id] : dictionaryMap[143];

    return {
        gttd: {
            id: 1,
            text: dictionary.gttd
        },
        gttd_advertizing: {
            id: 2,
            text: dictionary.gttd_advertizing
        },
        not_gttd: {
            id: 3,
            text: dictionary.not_gttd
        },
        no_gttd_advertizing: {
            id: 4,
            text: dictionary.not_gttd_advertising
        }
    };
};